import React from 'react';
import styled from 'styled-components';
import { Row, Col } from "reactstrap";
import { OutputRow, TableIcon, BoldLabel } from "../../../../utils/budget-tool-specific";
import { RebelColors } from "../../../../styles/rebel-experiences";
import SubtotalColumns from "../../experiences/cost-summary/subtotal-cols";
import { displayValue } from '../../helper';
import { calculateContingency } from '../../experiences/cost-summary/cost-helper';

const RebelContingencyRow = ({guideData, expData}) => {

    return(
        <React.Fragment>
            <RebelNoBorderRow>
                <Col lg="1"/>
                <Col>
                    <Row>
                        <Col sm={{size: 'auto'}}>
                            <TableIcon icon={['fas', 'shield-alt']}/>
                        </Col>
                        <Col>
                        <BoldLabel>
                            Contingency
                        </BoldLabel>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <RebelText>({guideData.contingency.value}%)</RebelText>
                </Col>
                <Col lg="2">
                    <RebelText>{guideData.currency.value.slice(3)}{displayValue(calculateContingency(guideData, expData))}</RebelText>
                </Col>
                <Col lg="1">
                    <RebelText>x {guideData.attendees.value}</RebelText>
                </Col>
                <Col lg="2">
                    <RebelText>
                        {guideData.currency.value.slice(3)}{displayValue(calculateContingency(guideData, expData)* guideData.attendees.value)}
                    </RebelText>
                </Col>
            </RebelNoBorderRow>
        </React.Fragment>
    )
}

export default RebelContingencyRow;

const RebelNoBorderRow = styled(OutputRow)`
    && {
        border-bottom: none !important;
    }
`;

const RebelText = styled.p`
    color: ${RebelColors.primary};
`;
